/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIChingConsultationDto } from '../../models/platform-api-result-of-i-ching-consultation-dto';
import { PlatformCreateIChingConsultation } from '../../models/platform-create-i-ching-consultation';

export interface PostIchingConsultationsActionCreate$Params {
      body: PlatformCreateIChingConsultation
}

export function postIchingConsultationsActionCreate(http: HttpClient, rootUrl: string, params: PostIchingConsultationsActionCreate$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, postIchingConsultationsActionCreate.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>;
    })
  );
}

postIchingConsultationsActionCreate.PATH = '/api/iching/consultations/action/create';
